import React from 'react';
import vars from '@variables';
import {
  ChevronLeftAtom,
  ChevronRightAtom,
} from '@atoms/icon-atoms/nav-icon-atoms';
import { ScrollArrowButton } from './scroll-arrows.styles';
import { ScrollArrowProps } from './scroll-arrows.types';

const ScrollArrow = ({
  direction,
  showArrow,
  scrollTabs,
}: ScrollArrowProps) => {
  const isLeft = direction === 'left';

  return (
    <ScrollArrowButton
      className={`scroll-arrow ${direction} ${showArrow ? 'visible' : ''}`}
      onClick={() => scrollTabs(direction)}
      aria-label={`Scroll ${direction}`}
    >
      {isLeft ? (
        <ChevronLeftAtom stroke={vars.emfBlue} width="19px" height="25px" />
      ) : (
        <ChevronRightAtom stroke={vars.emfBlue} width="19px" height="25px" />
      )}
    </ScrollArrowButton>
  );
};

export const LeftScrollArrow = ({ showLeftArrow, scrollTabs }) => {
  return (
    <ScrollArrow
      direction="left"
      showArrow={showLeftArrow}
      scrollTabs={scrollTabs}
      aria-label="Scroll left"
    />
  );
};

export const RightScrollArrow = ({ showRightArrow, scrollTabs }) => {
  return (
    <ScrollArrow
      direction="right"
      showArrow={showRightArrow}
      scrollTabs={scrollTabs}
      aria-label="Scroll right"
    />
  );
};
